import { Routes } from "@angular/router";

export const membershipDashboardRoutes: Routes = [
  {
    path: "",
    data: {
      tabs: [
        {
          key: "joinedRecently",
          title: "FRIENDS_OF_OMAN_MUSEUM.FRIENDS_JOINED_RECENTLY",
          routerLink: "joined-recently",
        },
        {
          key: "expired",
          title: "FRIENDS_OF_OMAN_MUSEUM.FRIENDS_WITH_EXPIRED_SUBSCRIBTION",
          routerLink: "expired",
        },
        {
          key: "expiresInCurrentMonth",
          title: "FRIENDS_OF_OMAN_MUSEUM.FRIENDS_WITH_SUBSCRIPTION_EXPIRES_IN_CURRENT_MONTH",
          routerLink: "expires-in-current-month",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "",
        redirectTo: "joined-recently",
        pathMatch: "full",
      },
      {
        path: "joined-recently",
        title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_DASHBOARD",
        loadComponent: () =>
          import("./pages/membership-joined-recently/membership-joined-recently.component").then(
            (c) => c.MembershipJoinedRecentlyComponent,
          ),
      },
      {
        path: "expired",
        title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_DASHBOARD",
        loadComponent: () => import("./pages/membership-expired/membership-expired.component").then((c) => c.MembershipExpiredComponent),
      },
      {
        path: "expires-in-current-month",
        title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_DASHBOARD",
        loadComponent: () =>
          import("./pages/membership-current-month-expires/membership-current-month-expires.component").then(
            (c) => c.MembershipCurrentMonthExpiresComponent,
          ),
      },
    ],
  },
];
